module.exports = __webpack_public_path__ + "img/purpose_2.a9436d02.png";